var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMortarboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_109_9484)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_109_9484",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_109_9484",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_109_9484",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEMklEQVR4nO2cT6hVVRTGj2makqXkn8L+oBGGzgzCgRJGIA4cFDQqDAokDAwc2KwUJ4JNBB00aJIF8ihQ3qBBk4ogkoZFTYQKirJHiaZket9Ptm/Ru1zuve/efc/ZZ+1zvh8ceNx32Get/e23v333W/sUhRBCCCGEEEIIIYQQQgghhHANsBJ41q6VdcfTSoC1wD5gGviXeW4CXwFvAg/XHWejAbYCb1mHzzIa3wPHgR3AorpzyBpgsXVk6NAfmZyfgPeAvcDSuvPLAmCFdVjouN+pjr+AKZv27q8771z8IBXynUg/SEXzfacCP0hFc3wnoR+kIj/fceAHdfjOI4UnnPtB830nYz9oju800A/y850W+UEqbkX5DrAN+LzFfpCC0LdfA08vJMajwOUkIYnAP8BjwwQ5duc2kZJjwwR5P2koInB2mCCv37lFpGRqmCD32EpAeBDERFkGHDBhwlJN1ClIn+8irwLngGsVB9ZkrpUiSJ/p7DngJPBrwmRyZQb4AHgRuLd0QXrEuQt4CjgCfJswSe9ctAEbBu6Snj6rTpA+Am2yLYHPbGu6LXRsQIaBuWWBPkonSM+DH7A9sLCpdoXmcd0GXhiAD43RL/UI0lDfmenyg6jqSBeCZO47Fwf5QWT+vgTJwHc6o/pBZL6+BXHiO9dj/KDxgnQDLO/ynd88+kGrBKnId0r1g2wFCR1acnubgcO2zxbm/EF07J5w72YPOXkR5AzwqW3rbyi57XXAa8B5m4Zm7Ofw2bqSn7XBcgi5nMlZkGDSvfVLR2wacl03y/wqsLfebKpJgritm2X0erPGClJ73Sxx9WatECTZeQ0mrzdrnSCl182WXH/cekHG9p2K648lyBDf+cS+a+yz67B9Fn5XFRLEGRLEGRLEGRLEGRLEGRLEGRLEGRLEGRLEGRLEGRIkd0HCrvWQ9r5M9n/+knZ7sxYE2AlcWqDNL4BV1SkxH0yrBWHuVPOfI7Y7XXZRyKBt8DVWLbIbeAM4DVwAbuCXG8A3wCmLebflEHJZPEb+H4753L2VCjLC0bntwDsmUIf66FgMb1tMy0rIb3XEoJsuvAA8aCU8weRSMGtvrAhH9tZXkE8Qdlx+KTwCPAm8O4IZxvAHcKLsAro+OeyJiO1q4RlgKfCKlYJOynfAy6lKjoCNETFeKHIAuBvYH/6kI5L8AXihjsI8e/Y4HC1ygrmFwMERl5KXrPxzSY3xhkqXcTxtU5EjzK1gTg5Ymc3acYM1TuL8e0RBPi5yB9gF/NxTJvRM4Qhb1i9EeGPG1qIJAKuAj+xy9/pW4D6rzB9GVEW9iMTqxQbxH/B4bNsivqi7e2rt5lRMm2JCgOf7iBEq7ldP2raIxE54dfNSbFuiBGw7Prz4EttHc32KrBUAh+z9WU/UHYso/j/qvUedIYQQQgghhBBCCCGEKMrkNgWvmTwUGkWQAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortarboard);
export default __webpack_public_path__ + "static/media/Mortarboard.c0bb6f240290c946bde5f5366bf00b1d.svg";
export { ForwardRef as ReactComponent };